import {
  ArrowRightIcon,
  BodyText,
  CaptionText,
  Card,
  Col,
  Icon,
  Link,
} from '@paypalcorp/pp-react'
import React from 'react'
import { HELP_CHANNEL_DATA } from '../../utils/prop-type-shape'
import { componentNames, fptiTypes } from '../../utils/analytics/fpti-constants'

// Hooks
import useTracking from '../../hooks/useTracking'

// styles
import './help-option.less'

// HelpOption Component to render individual help option card
function HelpOption({ iconName, title, desc, target, url, id }) {
  const { trackClick } = useTracking()

  const handleOnClick = (event) => {
    event.preventDefault()

    // Track click event through FPTI
    trackClick({
      name: componentNames.MORE_WAYS_OF_HELP,
      type: fptiTypes.ON_CLICK,
      link: `help-option|${id}|clicked`,
    })

    window.open(url, target || '_blank')
  }

  return (
    <Col
      data-testid="hc-help-option-col"
      sm={6}
      lg={4}
      className="more-help-option"
    >
      <Card
        onClick={(e) => handleOnClick(e)}
        className="more-help-option__card"
        data-testid="hc-help-option-card"
      >
        <div className="more-help-option__icon">
          <Icon
            className="more-help-option__icon--primary"
            size="lg"
            name={iconName}
            data-testid="hc-help-option-icon"
          />
        </div>
        <div className="more-help-option__content">
          <BodyText
            data-testid="hc-help-option-name"
            className="more-help-option__content--primary"
            size="sm"
            strong={true}
          >
            {title}
          </BodyText>
          <CaptionText
            data-testid="hc-help-option-desc"
            className="more-help-option__content--primary"
          >
            {desc}
          </CaptionText>
        </div>
        <div className="more-help-option__icon">
          <Link
            target={target}
            href={url}
            aria-label={`${title} ${desc}`}
            data-testid="hc-help-option-link"
          >
            <ArrowRightIcon
              className="more-help-option__icon--primary"
              size="sm"
            />
          </Link>
        </div>
      </Card>
    </Col>
  )
}

HelpOption.propTypes = HELP_CHANNEL_DATA

export default HelpOption
